
import React from 'react';
import { Card } from "@/components/ui/card";
import { ProgressBar } from '@/components/league-table/stats/components/ProgressBar';

interface GoalsStatsCardProps {
  title: string;
  titleDescription?: string;
  stats: { label: string; homeValue: number; awayValue: number; total: number }[];
}

export const GoalsStatsCard: React.FC<GoalsStatsCardProps> = ({ title, titleDescription, stats }) => {
  const calculateAverage = () => {
    const totalHomeOccurrences = stats.reduce((sum, stat) => sum + stat.homeValue, 0);
    const totalAwayOccurrences = stats.reduce((sum, stat) => sum + stat.awayValue, 0);
    
    const matches = stats[0]?.total || 1;
    const homeAvg = totalHomeOccurrences / matches;
    const awayAvg = totalAwayOccurrences / matches;
    
    return {
      home: isNaN(homeAvg) ? '0' : homeAvg.toFixed(1),
      away: isNaN(awayAvg) ? '0' : awayAvg.toFixed(1)
    };
  };

  const averages = calculateAverage();

  return (
    <Card className="p-4">
      <h3 className="text-lg font-semibold mb-1">{title}</h3>
      {titleDescription && (
        <p className="text-sm text-muted-foreground mb-4">{titleDescription}</p>
      )}
      <div className="grid grid-cols-11 items-center gap-2 mb-6">
        <div className="col-span-2 text-right text-blue-600 text-sm font-medium">
          Avg: {averages.home}
        </div>
        <div className="col-span-3">
        </div>
        <div className="col-span-1 text-center text-sm font-medium">
          Average
        </div>
        <div className="col-span-3">
        </div>
        <div className="col-span-2 text-left text-red-600 text-sm font-medium">
          Avg: {averages.away}
        </div>
      </div>
      <div className="space-y-4">
        {stats.map(({ label, homeValue, awayValue, total }) => {
          const homePercentage = total > 0 ? ((homeValue / total) * 100) : 0;
          const awayPercentage = total > 0 ? ((awayValue / total) * 100) : 0;
          const formattedHomePercentage = isNaN(homePercentage) ? '0' : homePercentage.toFixed(1);
          const formattedAwayPercentage = isNaN(awayPercentage) ? '0' : awayPercentage.toFixed(1);
          
          return (
            <div key={label} className="space-y-2">
              <div className="grid grid-cols-11 items-center gap-2">
                <div className="col-span-2 text-right text-blue-600 text-sm whitespace-nowrap">
                  {homeValue || 0} ({formattedHomePercentage}%)
                </div>
                <div className="col-span-3 relative">
                  <ProgressBar percentage={formattedHomePercentage} color="bg-blue-500" direction="left" />
                </div>
                <div className="col-span-1 text-center text-sm">{label}</div>
                <div className="col-span-3 relative">
                  <ProgressBar percentage={formattedAwayPercentage} color="bg-red-500" direction="right" />
                </div>
                <div className="col-span-2 text-left text-red-600 text-sm whitespace-nowrap">
                  {awayValue || 0} ({formattedAwayPercentage}%)
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </Card>
  );
};
